import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddressBlock from "../addAddress/addressBlock";
import {
  selectCateringCustomerAddresses,
  selectCateringSelectedAddress,
} from "../../redux/features/cateringCustomer/cateringCustomerSelectors";
import { transformAddresses } from "../../utils/addresses";
// Removed getBrandsByAreaAsync import as catering shows all brands regardless of area
import { setSelectedAddress } from "../../redux/features/cateringCustomer/cateringCustomerSlice";

export const CateringAddressSelection = ({ isCheckout = false, setShowAddressForm }) => {
  const addressData = useSelector(selectCateringCustomerAddresses);
  const selectedAddress = useSelector(selectCateringSelectedAddress);
  const addresses = addressData && transformAddresses(addressData);
  const dispatch = useDispatch();

  // State to track the selected address ID
  const [selectedAddressId, setSelectedAddressId] = useState(
    selectedAddress?.id || null
  );

  // Handle address selection/deselection
  const handleSelectAddress = (id) => {
    console.log("Selected catering address ID:", id); // Debug log
    setSelectedAddressId(id);

    // If id is null, deselect current address
    if (id === null) {
      dispatch(setSelectedAddress(null));
      return;
    }

    // Find the address object with the matching ID
    const selectedAddressObj = addresses.find((address) => address.id === id);

    if (selectedAddressObj) {
      // Dispatch to Redux
      dispatch(setSelectedAddress(selectedAddressObj));
      
      // For catering, we show all brands regardless of area
      // No need to fetch brands by area like in delivery service
    }
  };

  // Set selected address ID from Redux on mount and when it changes
  useEffect(() => {
    // Only update if there's a change to prevent loops
    if (selectedAddress?.id !== selectedAddressId) {
      setSelectedAddressId(selectedAddress?.id || null);
    }
  }, [selectedAddress]);

  // For catering, we don't need to initialize brands based on area
  // All brands should be available regardless of the selected address area

  return (
    <div className="flex flex-col w-full">
      {/* Header - always show */}
      <h1 className="text-3xl font-bold text-gray-500 mb-4">Address List</h1>
      
      {/* Show addresses if they exist */}
      {addresses && addresses.length > 0 ? (
        <div className="w-full overflow-y-auto overflow-x-hidden max-h-[550px] pr-2">
          <div
            className="grid gap-6"
            style={{
              gridTemplateColumns: "repeat(auto-fill, minmax(257px, 1fr))",
            }}
          >
            {addresses.map((address, index) => (
              <AddressBlock
                key={address.id || index}
                address={address}
                isAddressBlockVisible
                isSelected={selectedAddressId === address.id}
                onSelect={(id) =>
                  handleSelectAddress(id === null ? null : address.id)
                }
                selectedAddress={selectedAddress}
                isCheckout={isCheckout}
                showSwitchButton={
                  isCheckout && selectedAddressId !== address.id
                }
                setShowAddressForm={setShowAddressForm}
              />
            ))}
          </div>
        </div>
      ) : (
        /* Show message when no addresses */
        <div className="w-full p-6 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 text-center">
          <svg className="mx-auto h-12 w-12 text-gray-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <p className="text-gray-600 font-medium text-lg mb-1">No addresses found</p>
          <p className="text-gray-500 text-sm">Please add a new address to continue with your catering order</p>
        </div>
      )}
    </div>
  );
};
